import deleteSubscriber from './deleteSubscriber';

export default deleteSubscriber;
